module.exports = __webpack_public_path__ + "img/icon-4.899511ea.png";